// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import X from "@insite/mobius/Icons/X";
import { RadioStyle } from "@insite/mobius/Radio";
import { configureBudgetStyles } from "@steiner/Overrides/Widgets/Budget/ConfigureBudget";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { createLinkIconStyles, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

configureBudgetStyles.gridContainer = {
    gap: 0,
};

configureBudgetStyles.removeLink = {
    ...createLinkIconStyles({
        icon: X,
        linkStyles: {
            icon: {
                iconProps: {
                    size: 16,
                    css: css`
                        margin-right: 6px;
                    `,
                },
            },
            typographyProps: {
                size: 16,
                lineHeight: 22,
                weight: fontConfig.weight.bold,
            },
        },
    }),
};

configureBudgetStyles.titleGridItems = {
    width: [12, 12, 8, 8, 8],
    css: css`
        padding-bottom: 0;
    `,
};

configureBudgetStyles.titleText = {
    variant: "h1",
    as: "h1",
    css: css`
        ${xScreen("lte", "sm")} {
            margin: 0;
        }
    `,
} as any;

configureBudgetStyles.enforcementLevelLabel = {
    variant: "h4",
    as: "h4",
    css: css`
        display: inline-block;
        margin-right: 6px;
        margin-bottom: 0;
    `,
} as any;

configureBudgetStyles.budgetPeriodTitle = {
    variant: "h4",
    as: "h4",
    css: css`
        display: inline-block;
        margin-right: 6px;
    `,
} as any;

configureBudgetStyles.saveButton = {
    css: css`
        margin-left: 16px;
    `,
};

configureBudgetStyles.enforcementLevelRadioGroup = {
    css: css`
        display: flex;
        flex-direction: row;
        && > ${RadioStyle} {
            display: inline-block;
            margin-right: 16px;
            margin-top: 8px;
        }
        ${xScreen("lte", "sm")} {
            flex-direction: column;
        }
    `,
};

configureBudgetStyles.gridItems = {
    css: css`
        padding-top: 20px;
    `,
};

configureBudgetStyles.budgetYearSelectorStyles = {
    select: {
        css: css`
            min-width: 204px;
        `,
    },
    wrapper: {
        css: css`
            display: inline-block;
            margin: 0;
        `,
    },
};

configureBudgetStyles.tableGridItems = {
    width: [12, 12, 12, 6, 6],
    css: css`
        padding: 15px 0 8px;
        & > div {
            overflow: unset;
        }
        ${xScreen("lte", "sm")} {
            padding: 15px 0;
        }
    `,
};

configureBudgetStyles.budgetPeriodTypeRadioGroup = {
    css: css`
        display: flex;
        flex-direction: row;
        && > ${RadioStyle} {
            display: inline-block;
            margin-right: 16px;
            margin-top: 0;
        }
        ${xScreen("lte", "sm")} {
            flex-direction: column;
        }
    `,
};

configureBudgetStyles.startDatePicker = {
    cssOverrides: {
        datePicker: css`
            ${xScreen("lte", "sm")} {
                min-width: unset;
            }
        `,
    },
};

configureBudgetStyles.buttonsGridItem = {
    width: [12, 12, 4, 4, 4],
    css: css`
        justify-content: flex-end;
        ${xScreen("lte", "sm")} {
            justify-content: flex-start;
            padding: 20px 0;
            > div[class^="HiddenStyle"] {
                display: flex;
            }
        }
    `,
};
